module.exports = __webpack_public_path__ + "img/img3.3be6f3f1.png";